import React from 'react';
import { styled } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { Colors } from 'library';
import { Link } from 'react-router-dom';
import { BaseButton } from './BaseButton';

interface BackLinkProps {
    label: string;
    to?: string;
    onClick?: () => void;
}

export function BackLink({ label, to, onClick }: BackLinkProps) {
    const content = (
        <>
            <ArrowBack sx={{ fontSize: 18 }} />
            {label}
        </>
    );

    if (onClick) {
        return (
            <StyledBackButton type="button" onClick={onClick}>
                {content}
            </StyledBackButton>
        );
    }

    return <StyledBackLink to={to ?? ''}>{content}</StyledBackLink>;
}

const backLinkStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 14,
    color: Colors.textSecondary,
    textDecoration: 'none',
    padding: 0,
    marginBottom: 8,
    '&:hover': {
        color: Colors.primary,
    },
} as const;

const StyledBackLink = styled(Link)(backLinkStyles);
const StyledBackButton = styled(BaseButton)(backLinkStyles);
